import FingerprintJS from '@fingerprintjs/fingerprintjs';

let fpPromise = null;

export const getDeviceId = async () => {
    try {
        if (!fpPromise) {
            fpPromise = FingerprintJS.load();
        }
        const fp = await fpPromise;
        const result = await fp.get();
        return result.visitorId;
    } catch (error) {
        console.error("Error getting fingerprint deviceId:", error);
        let fallbackId = localStorage.getItem("deviceId");
        if (!fallbackId) {
            fallbackId = "dev_" + Math.random().toString(36).substring(2, 11) + "_" + Date.now();
            localStorage.setItem("deviceId", fallbackId);
        }
        return fallbackId;
    }
};
